import pagination from '@/common/components/pagination'
import Auth from '@/common/auth'
import Cache from '@/common/cache'

export default {
    components: { pagination },
    data: () => ({
        mask_data: '##/##/####',
        mask_cpf: '###.###.###-##',
        mask_rg: '##.###.###-#',
        mask_tel: '####-####',
        mask_cel: '#####-####',
        mask_cep: '#####-###',
        mask_ddd: '##',
        money: {
            decimal: ',',
            thousands: '.',
            precision: 2,
            masked: false,
        },
        optionsJsonEditor: {
            mode: 'code'
        }
    }),
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return 'R$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        defaultPageChanged: function (filter, index) {
            filter.pageIndex = index;
            return filter;
        },
        defaultOrderBy: function (filter, field) {
            let type = 0;
            if (filter.orderByType == 0) type = 1;
            filter.orderFields = field;
            filter.orderByType = type;
            filter.isOrderByDynamic = true;
            return filter;
        },
        defaultPageSizeChanged: function (filter, size) {
            filter.pageIndex = 1;
            filter.pageSize = size;
            return filter;
        },
        defaultInfoMessage: function (msg) {
            this.hideLoading();
            this.$eventHub.$emit('show-notification', {
                type: 'info',
                title: 'Info',
                text: msg
            })
        },
        defaultWarningMessage: function (msg) {
            this.hideLoading();
            this.$eventHub.$emit('show-notification', {
                type: 'warning',
                title: 'Warning',
                text: msg
            })
        },
        defaultSuccessResult: function (msg) {
            this.hideLoading();
            this.$eventHub.$emit('show-notification', {
                type: 'success',
                title: 'Sucesso',
                text: msg
            })
        },
        defaultErrorResult: function (err) {
            this.hideLoading();
            if (!err) {
                this.$eventHub.$emit('show-notification', {
                    type: 'error',
                    title: 'Atenção',
                    text: "Erro"
                })
                return;
            }

            if (err.data && err.data.errors) {
                for (var i = 0; i < err.data.errors.length; i++) {
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors[i]
                    })
                }
            }

            else
                this.$eventHub.$emit('show-notification', {
                    type: 'error',
                    title: 'Atenção',
                    text: err
                });
        },
        configNotification() {
            this.$eventHub.$on('show-notification', (data) => {
                this.$notify({
                    type: data.type,
                    title: data.title,
                    text: data.text,
                    duration: 10000,
                    speed: 1000
                })
            })
        },
        showLoading: function () {
            this.$eventHub.$emit('show-loading', true)
        },
        hideLoading: function () {
            this.$eventHub.$emit('show-loading', false)
        },
        failLoading: function () {
            this.$eventHub.$emit('show-loading', false)
        },

    },
    mounted() {
        var user = Auth.currentUser();
        var escolaBox = Cache.get("escola_box");

        if (escolaBox) {
            if (user.tenant != escolaBox) {
                window.location = "/acessonegado";
            }
        }

        window.scrollTo(0, 0);
    },
}
